import { LoadingComponent } from "../components/Loading/LoadingVideoComponent";

function SuspenseContent() {
  return (
    <div className="w-full h-screen text-gray-300 dark:text-gray-200 bg-base-100">
      <LoadingComponent />
    </div>
  );
}

export default SuspenseContent;
